import BaseApi from '../base/base'
import UserBlock from '../../models/user_block'

export default class UserBlockApi extends BaseApi {
  constructor() {
    super()
    this.path = '/user_blocks'
  }

  async index(params = {}) {
    this.path = '/user_blocks'
    const response = await this.getRequest(params)
    return response.data.map(item => new UserBlock(item))
  }
}
